import { CompanyInfo } from '@epi-models/pages/CompanyInfo';

export const getLastCompanyInformation = (state): CompanyInfo =>
  state.apiCompany.lastCompanyInformation;
